module.exports = __webpack_public_path__ + "static/media/black-hoodie-man-back-min.07df8ff6.png";